import React, { useEffect, useRef } from 'react';
import './Article.scss';
import { gsap } from './gsap';
import { createPopper } from '@popperjs/core';
import Hero from './Components/Hero/Hero';
import Header from './Components/common-header/Header';
import Footer from './Components/common-footer/Footer';
import InlinePhoto from './Components/Photos/InlinePhoto';
import Chapter1 from './Components/Chapters/Chapter1';
import Chapter2 from './Components/Chapters/Chapter2';
import Chapter3 from './Components/Chapters/Chapter3';
import Chapter4 from './Components/Chapters/Chapter4';
import Chapter5 from './Components/Chapters/Chapter5';
import Chapter6 from './Components/Chapters/Chapter6';
import Chapter7 from './Components/Chapters/Chapter7';
import PullQuoteWImg from './Components/PullQuote/PullQuoteWImg';
import EmphasizedParagraph from './Components/EmphasizedParagraph/EmphasizedParagraph';
import contents from './contents';
import FullWidthPhoto from './Components/Photos/FullWidthPhoto';
import RelatedContents from './Components/RelatedContents/RelatedContents';
import CtaButton from './Components/CtaButton/CtaButton';
import Reference from './Components/Reference/Reference';

//for full width photos
import fullWidthImage1 from './assets/fullWidthImage1.jpg';
import fullWidthImage2 from './assets/fullWidthImage2.jpg';
import fullWidthImage3 from './assets/fullWidthImage3.jpg';

//for pq images
import pqImg1 from './assets/pqImg1.jpg';

function Article({ heroBackgroundType, inlinePhotoSize, logoPlacement }) {
  //create refs for photos here if you want to add scale animation on scroll
  const inline1 = useRef();
  const inline2 = useRef();
  const inline3 = useRef();
  const inline4 = useRef();
  const inline5 = useRef();
  const inline6 = useRef();
  const inline7 = useRef();
  const inline8 = useRef();
  const allPhotosRef = useRef();
  allPhotosRef.current = [inline1, inline2, inline3, inline4, inline5, inline6, inline7, inline8]; // put all photo refs in this array

  const photoSize = inlinePhotoSize !== undefined ? inlinePhotoSize : contents.inlinePhotos.size;

  //creates/shows tooltip element when mouse enters
  const handleMouseEnterTooltip = (e, currentRef) => {
    const content = currentRef.current;
    createPopper(e.target, content, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
  };

  //hides tooltip element when mouse leaves
  const handleMouseLeaveTooltip = (currentRef) => {
    currentRef.current.style.visibility = 'hidden';
  };

  useEffect(() => {
    allPhotosRef.current.forEach((photo) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: photo.current,
          start: '20% bottom',
          end: 'top center',
          scrub: 1
        }
      });
      tl.to(photo.current, {
        width: '100%',
        height: '100%',
        duration: 3
      });
    });
  }, []);

  return (
    <div className="article">
      <Header clientName={contents.header} />
      <Hero
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
        heroBackgroundType={heroBackgroundType}
        logoPlacement={logoPlacement}
      />
      <Chapter1 />

      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[0]} //pass in corresponding data
        photoRef={inline1} //pass in ref
      />

      <Chapter2 />
      <FullWidthPhoto
        photo={fullWidthImage1}
        alt={'lady at computer'}
        caption={
          "The scalability and flexibility of the AWS cloud with Intel technologies allows Company 3's postproduction artists to connect from anywhere in the world and collaborate in virtual workrooms. (Getty Images)"
        }
      />
      <Chapter3 />

      <FullWidthPhoto
        photo={fullWidthImage2}
        alt={'aws'}
        caption={
          'Using the AWS cloud with Intel technologies helped Company 3 receive and deploy footage for films and TV series in production (often at massive file sizes) securely around the world. (Company 3)'
        }
      />

      <Chapter4 />
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[3]} //pass in corresponding data
        photoRef={inline4} //pass in ref
      />
      <Chapter5 />
      <PullQuoteWImg
        quote={'Every human emotion we can put into the image [...] that’s the reward.'}
        author={'Robert Keske'}
        descrip={'CTO, Company3'}
        photo={pqImg1}
      />
      <Chapter6 />
      <FullWidthPhoto
        photo={fullWidthImage3}
        alt={'rings of power '}
        caption={
          'To bring of the magic of The Rings of Power to life, much of the postproduction work happened while the Company 3 global team was working remotely. (Amazon Prime Video)'
        }
      />

      <Chapter7 />
      <Reference />
      <EmphasizedParagraph />
      <CtaButton
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
      />
      <div className="article__divider" />

      <RelatedContents />
      <Footer />
    </div>
  );
}

export default Article;
